async function obtenerSHA512(cadena) {
  // Convertir la cadena a un buffer de datos
  const encoder = new TextEncoder();
  const datos = encoder.encode(cadena);

  // Calcular el hash
  const hashBuffer = await crypto.subtle.digest("SHA-512", datos);

  // Convertir el hash a una representación hexadecimal
  // eslint-disable-next-line no-undef
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, "0")).join("");

  return hashHex;
}

export { obtenerSHA512 };
